/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_SyncingInputs */



/**
* | output |
* | --- |
* | "This space is syncing. You can save once the sync has finished." |
*
* @param {Spaces_Connection_Settings_SyncingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_syncing = /** @type {((inputs?: Spaces_Connection_Settings_SyncingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_SyncingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Space wird gerade synchronisiert. Speichern ist möglich, sobald die Synchronisierung abgeschlossen ist.")
	return /** @type {LocalizedString} */ ("This space is syncing. You can save once the sync has finished.")
});